export { USER } from './constants';

export {
  login,
  setUpAuth,
  clearIncorrectPasswordError,
  clearInvalidEmailError,
  clearWeakPasswordError,
  clearUnavailableEmailError,
  createCustomer,
  updateCustomer,
  addPaymentSource,
  createCustomerSubscription,
  updateCustomerSubscription,
  cancelSubscription,
  getPlanName,
  fetchCoupon
} from './actions';

export { default as reducer } from './reducer';

export {
  isLoggedIn,
  isLoggingIn,
  isSettingUpAuth,
  showIncorrectPasswordError,
  showInvalidEmailError,
  showUnavailableEmailError,
  showWeakPasswordError,
  getUser,
  isCreatingCustomer,
  isCreatingSubscription,
  isFetchingCoupon,
  showIncorrectCouponError,
  showCouponSuccess
} from './selectors';



// WEBPACK FOOTER //
// ./src/redux/user/index.js